const Secret = process.env.VUE_APP_SECRET;
const ApiUrl = process.env.VUE_APP_BASE_URL + "/v1/";
const PDFUrl = process.env.VUE_APP_PDF_URL;
const AgentUrl = process.env.VUE_APP_AGENT_URL;
const NewsUrl = process.env.VUE_APP_NEWS_URL;
const UploadUrl = process.env.VUE_APP_BASE_URL + "/upload";
const PageSize = 14;
const NotifyDuration = 3000;

const Status = ['待定', '发布', '下架']
const NewsTag = [
  '教育研究',
  '学业规划',
  '高考志愿',
  '大学与专业',
  '升学通道',
  '学业活动',
  '就业活动',
  '能力活动',
];
const AgentTag = [
  '职业能力',
  '学业规划',
  '高考志愿',
];
const CustomerTag = [
  '捐赠客户',
  '活动客户',
  '顾问客户',
];
const AbilityTag = [
  '职业能力',
  '学业规划',
  '高考志愿',
];
const StatusTag = [
  '签约',
  '解约',
  '合作',
];

const AsideMenus = [
  {
    icon: "dashboard",
    title: "仪表盘",
    path: ["/dashboard/index", "/dashboard/index"],
    roles: ['admin', 'agent']
  },
  {
    icon: "agent",
    title: "顾问服务",
    path: ["/agent/list", "/agent/service"],
    roles: ['admin', 'agent']
  },  
  {
    icon: "customer",
    title: "客户订单",
    path: ["/customer/list"],
    roles: ['admin']
  },
  {
    icon: "news",
    title: "文章活动",
    path: ["/news/list"],
    roles: ['admin']
  },
  // {
  //   icon: "setting",
  //   title: "设置",
  //   path: "/setting/index"
  // },
];


export const consts = {
  Secret,
  ApiUrl,
  PDFUrl,
  AgentUrl,
  NewsUrl,
  UploadUrl,
  PageSize,
  NotifyDuration,
  Status,
  NewsTag,
  AgentTag,
  CustomerTag,
  AbilityTag,
  StatusTag,
  AsideMenus,
};
